import React from 'react';
import Alert from "../Alert";
import {LENDERS} from "../../consts/tables";
import LenderForm from "../LenderForm/LenderForm";
import {manageData} from "../../requests/CRUD";
import { ApolloConsumer } from '@apollo/client';
import { CREATE_UPDATE_LENDER } from '../Graphql/mutations';
import { CREATE_OR_UPDATE_CONTACTS_LENDERS } from '../Graphql/ContactsMutations/allContactsMutation';
import { mutateData } from '../Service/graphQlService';

export default class LenderDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.client = null;
        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
            newLender: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{}});
    }

    handleSubmit(e) {
        e.preventDefault();
        //Added if consition newly earlier it was not there
        if(this.client){
            this.saveData(this.client);
        }
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    async saveData(client) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        // manageData({
        //         tableCode: LENDERS,
        //         data: [this.state.data]
        // }).then(res => {
            const token = localStorage.getItem('authToken');
        try {
            const input = {};
            // List of fields to include in the input
            // const fields = [
            //     "NAME",
            //     "CITY",
            //     "STATE",
            //     "CONTACT_NAME",
            //     "CONTACT_PHONE",
            //     "CONTACT_EMAIL"
            // ];
            const fields = [
                "name",
                "city",
                "state",
                "contact_name",
                "contact_phone",
                "contact_email"
            ];

            // Dynamically add fields to the input if they exist in `this.state.data`
            fields.forEach(field => {
                if (this.state.data[field]) {
                input[field] = this.state.data[field] ;
                }
            });
            input.contact_type = "Lender";
        // const res = await client.mutate({
        //     //mutation: CREATE_UPDATE_LENDER,
        //   mutation: CREATE_OR_UPDATE_CONTACTS_LENDERS,
        //   variables: {
        //     input: input
        //   },
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,  // Bearer token added here
        //     },
        //   },
        //})
        const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_LENDERS,{input})
            //if (res && res.success) {
                //if (res && res.data.createOrUpdateLenders.success) {
                if (res && res.data.createOrUpdateContact.success) {
                this.setState({isBusy: false});
                //this.props.savedNewItem(res.data[0]);
                //this.props.savedNewItem(res.data.createOrUpdateLenders.data[0]);
                this.props.savedNewItem(res.data.createOrUpdateContact.contact);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}), 1000);
                }
            } else {
                this.setState({
                    isBusy: null,
                    //error: res && res.message ? res.message : 'Unspecified error',
                    //error: res && res.data.createOrUpdateLenders.message ? res.data.createOrUpdateLenders.message : 'Unspecified error',
                    error: res && res.data.createOrUpdateContact.message ? res.data.createOrUpdateContact.message : 'Unspecified error',
                });
            } } catch (error) {
                console.error("Error in handleSubmit:", error);
              }
    }

    render() {
        const data = this.state.data;

        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <React.Fragment>
                <LenderForm data={data}
                            paneIndex={this.state.paneIndex}
                            handleSubmit={this.handleSubmit}
                            handleCancel={this.props.closeDrawer}
                            handleParentChange={this.handleChange}
                            handleParentDropdownChange={this.handleDropdownChange}
                            handlePaneChange={(key) => this.setState({paneIndex: key})}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
             )
            }}
    
        </ApolloConsumer>
        );
    }
}

